import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import axios from 'axios';
import { toError, assertOk } from '@/services/normalize';

import { BASE_URL, INVITE_FRIEND_FETCH, INVITE_FRIEND_EDIT, M_POST } from '@/utils/api';

@Module({ name: 'invitefriend' })
export default class InviteFriend extends VuexModule {
  inviteFriendList: any[] = [];

  @Mutation
  mutateInviteFriend(list: any[]) {
    this.inviteFriendList = list ?? [];
  }

  @Action({ commit: 'mutateInviteFriend', rawError: true })
  async FetchInviteFriends(params: Record<string, any> = {}) {
    try {
      const { data } = await axios({
        url: BASE_URL + INVITE_FRIEND_FETCH,
        data: params,
        method: M_POST
      });

      assertOk(data, 'Fetch invite friends failed');
      return data?.data;
    } catch (err: any) {
      throw toError(err, 'Fetch invite friends failed');
    }
  }

  @Action({ rawError: true })
  async UpdateUrl(params: Record<string, any>) {
    try {
      const { data } = await axios({
        url: BASE_URL + INVITE_FRIEND_EDIT,
        data: params,
        method: M_POST
      });

      assertOk(data, 'Update invite url failed');
      return data?.status;
    } catch (err: any) {
      throw toError(err, 'Update invite url failed');
    }
  }
}
